import { INavigationConfig } from '~/src/dash/views/common';

export const inventoryRulesNavigationConfig: INavigationConfig = {
  tabs: [
    { key: 'All', label: 'All', value: 0, tKey: 'All' },
    { key: 'Settings', label: 'Settings', value: 1, tKey: 'Settings' },
  ],
  defaultState: {
    activeTabIndex: 0,
  },
};
